import { animate, stagger } from "motion";

export class MobileMenu {
	constructor() {
		this.dialog = document.getElementById("mobile-menu");
		this.openBtn = document.querySelector(".mobile-menu__toggle--open");
		this.closeBtn = document.querySelector(".mobile-menu__toggle--close");

		if (!this.dialog || !this.openBtn) return;

		this.openBtn.addEventListener("click", () => this.open());
		this.closeBtn?.addEventListener("click", () => this.close());
	}

	open() {
		this.dialog.showModal();
		this.dialog.setAttribute("tabindex", "-1");
		this.dialog.focus();
		this.dialog.removeAttribute("tabindex");

		animate(
			".mobile-menu__list li, .mobile-menu__button",
			{ opacity: [0, 1], y: [-20, 0] },
			{ delay: stagger(0.03) }
		);
	}

	close() {
		this.dialog.close();
	}
}
